import { BsStars } from "react-icons/bs";
import styles from "./Note.module.scss";

export default function Note({ text, children, contentClassNames = [] }) {
  return (
    <aside className={`${styles.note}`}>
      <div
        className={`${styles.content}  ${
          contentClassNames ? [...contentClassNames] : ""
        }`}
      >
        <span className={`${styles.iconWrapper}`}>
          <BsStars size={25} />
        </span>
        {text && <p className={`${styles.text}`}>{text}</p>}
      </div>
      {children && children}
    </aside>
  );
}
